<template>
 <div class="foot" style="margin-top:20px">
  <div class="content">
    <div class="block2">
      <h2 class="small">江苏茂悦</h2>
      <p><a href="" class="product">ERP</a> <a href="javascript:;" class="product">BPM</a> <a href="javascript:;" class="product">CRM</a> <a href="javascript:;" class="product">PM</a> <a href="javascript:;" class="product">SCM</a></p>
      <br><h3><img src="/static/picture/telephone.png"><a href="about.html#contact">400-801-3695</a></h3>
      <br>垂询热线：400-801-3695
      <br>电子邮件：info@myferp.com
      <br>网站备案：<a class="textGray" href="https://beian.miit.gov.cn" target="_blank">苏ICP备13021550号-3</a>   
    </div><div class="block2" align="right">
      <br> 
	  <a class=button style='padding-top:4px;padding-bottom:2px;' href='http://wpa.qq.com/msgrd?v=3&uin=1455319488&site=qq&menu=yes' target=_blank><img border=0 src='/static/image/qq.png'> 在线咨询</a> 
	  <a class=button style='padding-top:4px;padding-bottom:2px;' href='http://wpa.qq.com/msgrd?v=3&uin=1455319488&site=qq&menu=yes' target=_blank><img border=0 src='/static/image/qq.png'> 在线咨询</a><br><br>
	  <a class=button style='padding-top:4px;padding-bottom:2px;' href='http://wpa.qq.com/msgrd?v=3&uin=1455319488&site=qq&menu=yes' target=_blank><img border=0 src='/static/image/qq.png'> 在线咨询</a><a class=button style='padding-top:4px;padding-bottom:2px;' href='http://wpa.qq.com/msgrd?v=3&uin=1455319488&site=qq&menu=yes' target=_blank><img border=0 src='/static/image/qq.png'> 在线咨询</a>
	  <br><br><a class=button style='padding-top:4px;padding-bottom:2px;' ><el-link  :underline="false" @click="handleMessage()"> <img border=0 src='/static/image/message.png'> 在线留言</el-link></a><a class=button style='padding-top:4px;padding-bottom:2px;' href='#'><img border=0 src='/static/image/up.png'> 返回顶端</a>
    </div>
    <p class="textSmall" style="padding:10px;"> 
      <br>&copy; 版权所有， 保留所有权利。 
    </p>
  </div>
</div>


</template>
 
 
<script>
    export default {
        name: "appFooter",
        data () {
            return {
	    	activeIndex: '1',
		    userInfo: {},
			login_state : 0,
            text: "hallo,word",
            img: "",
            arr: [],
			} 
			 
        },
        methods: {
            click() {
                console.log(1111)
            },
			logout()
			{
			  console.log('out');
			  localStorage.setItem('userInfo',  '');
			  window.location.href= '/out';  
			},
			handleMessage() {  
			   let newUrl = this.$router.resolve({
					  name: 'message',
					  params: {
					           
					          }
				     });
			   window.open(newUrl.href, "_blank");		   
             }
        },
        created() { 

        }
    }
</script>




// WEBPACK FOOTER //
// src/components/appFooter.vue